import { apiRequest } from '../../../lib/api';
import { API_PATHS } from '../../../lib/apiRoutes';
import { normalizeApprovalList } from '../lib/normalizeApprovals';
import type { ApprovalListPage, ApprovalListQuery } from '../types/approvals.types';

type ApprovalListEnvelope = {
  approvals?: unknown[];
  data?: { approvals?: unknown[]; total?: number; page?: number; limit?: number };
};

const toNonNegativeInt = (value: unknown, fallback: number): number => {
  const parsed = Number(value);
  return Number.isFinite(parsed) && parsed >= 0 ? Math.floor(parsed) : fallback;
};

export const approvalsApi = {
  list: async (params: ApprovalListQuery = {}): Promise<ApprovalListPage> => {
    const query = new URLSearchParams();
    if (params.status) query.set('status', params.status);
    if (params.type) query.set('type', params.type.trim().toLowerCase());
    if (params.limit) query.set('limit', String(params.limit));
    if (params.page) query.set('page', String(params.page));
    const suffix = query.toString() ? `?${query.toString()}` : '';
    const payload = await apiRequest<ApprovalListEnvelope>(`${API_PATHS.approvals.list}${suffix}`);
    const approvals = normalizeApprovalList(payload);
    return {
      approvals,
      total: toNonNegativeInt(payload?.data?.total, approvals.length),
      page: Math.max(1, toNonNegativeInt(payload?.data?.page, params.page || 1)),
      limit: Math.max(1, toNonNegativeInt(payload?.data?.limit, params.limit || approvals.length || 1))
    };
  },
};
